import React from 'react';
import { isNotEmpty, addHttpsIfMissing, isDesktop } from '../../lib/ep';

import { SquaredButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection';
import Tooltip from '../builder/Tooltip.js';
import ShareButton from './buttons/ShareButton';


const MyNetsButtons = (props) => {
	const promotion = props?.promotion ?? {};

	const networks = props?.networks ?? false;

	const type = props?.type ?? 'header';
	const include_path = props?.include_path ?? false;
	const is_builder = props?.is_builder ?? false;
	const display_my_networks = props?.display_my_networks ?? true;
	const display_share = ((promotion.config?.share?.status ?? '1') == '1') ?? true;

	if(networks === false && type == 'success') return null;

	const getNetworkLink = (net) => {
		if(!isNotEmpty(net,'target') && !isNotEmpty(net, 'target_user')) return false;
		if(include_path)return addHttpsIfMissing(net.target);
		switch(net.net) {
			case 'facebook':
				return (net.target.indexOf('facebook.com') != -1) ? net.target : `https://www.facebook.com/${net.target}`;

			case 'twitter':
				return (net.target.indexOf('twitter.com') != -1 || net.target.indexOf('//x.com') != -1 || net.target.indexOf('www.x.com') != -1) ? net.target : `https://twitter.com/${net.target}`;

			case 'instagram':
				return (net.target.indexOf('instagram.com') != -1) ? net.target : `https://www.instagram.com/${net.target}`;

			case 'pinterest':
				return (net.target.indexOf('pinterest.com') != -1) ? net.target : `https://www.pinterest.es/${net.target}`;

			case 'linkedin':
				return (net?.target != undefined && net.target.indexOf('linkedin.com') != -1) ? net.target : `https://www.linkedin.com/company/${net.target_user}`;

			case 'twitch':
				return (net.target.indexOf('twitch.tv') != -1) ? net.target : `https://www.twitch.tv/${net.target}`;

			case 'tiktok':
				return (net.target.indexOf('tiktok.com') != -1) ? net.target : `https://www.tiktok.com/@${net.target}`;

			case 'threads':
				return (net.target.indexOf('threads.net') != -1) ? net.target : `https://www.threads.net/@${net.target}`;

			case 'spotify':
				return (net.target.indexOf('spotify.com') != -1) ? net.target : `https://www.threads.net/@${net.target}`;

			case 'youtube':
				const user = (isNotEmpty(net, 'target_user')) ? net.target_user : net.target;

				let link_user = 'https://www.youtube.com/';
				if(!(net.target_user != undefined && net.target_user != '')) link_user += 'channel/';

				return (user.indexOf('youtube') != -1) ? user : link_user + user;
		}

		return false;
	};

	let ul_class = [];
	switch(type) {
		case 'success':
			ul_class.push('gui_inline_networks');
			break;

		case 'header':
		default:
			ul_class.push('gui_share_button');
			break;
	}

	return (
		<ButtonCollection _class={{ other:ul_class.join(" ") }}>
			{networks !== false && display_my_networks && networks.map((net, i) => {
				const link = getNetworkLink(net);
				if(link === false) return null;

				return (
					<SquaredButton
						key={`net_${i}`}
						icon={`ep-${net.net}`}
						color={false}
						_class={{ other:`${net.net}_btn` }}
						_href={(!is_builder) ? link : '#networks'}
						_target={(!is_builder) ? '_blank' : null}
						tooltip={(is_builder) ? <Tooltip with_icon={false} position="bottom">Edit My Networks</Tooltip> : null}
						aria-label="Edit My Networks"
					/>
				)
			})}

			{(type != 'success' && display_share) && (
				<ShareButton
					is_builder={is_builder}
					promotion={promotion}
					sharing_type="mynets"
					sharing_page="header"
					info={props.share_info}
					icon='knk-share'
					cta_type='simple_button'
					is_mobile={(!isDesktop()) ? true : false}
					enable_behavior={(is_builder) ? true : null}
				>Share</ShareButton>
			)}
		</ButtonCollection>
	)
}

export default MyNetsButtons;